export enum TechnicalDocumentationStatusDto {
  Created = 0,
  NotCreated = 1,
  Expired = 2,
  OlderVersion = 3,
}
